import LongLat from "@mapmycustomers/shared/types/base/LongLat";
import User from "@mapmycustomers/shared/types/User";
import { convertLongLatToLatLngLiteral } from "@mapmycustomers/shared/util/geo/GeoService";

export const getUserLastLocationCoordinates = (user: User): LongLat =>
  user.lastLocation!.geoPoint.coordinates;

const userLocationGeometryGetter = (
  user: User
): Exclude<google.maps.Data.FeatureOptions["geometry"], undefined> => {
  return new google.maps.Data.Point(
    convertLongLatToLatLngLiteral(getUserLastLocationCoordinates(user))
  );
};

export default userLocationGeometryGetter;
